export const schemaReveal = (props) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'description'],
      },  
      {
        id: 'style',
        title: 'Slide Style',
        fields: ['height','align', 'theme'],
      },
      {
        id: 'trans',
        title: 'Slide Transitions',
        fields: [
	  'transition', 'autoslide', 'loop', 'controls', 'keyboard',
	  'scrollactivationwidth'
	],
      },
      {
        id: 'content',
        title: 'Slide Content',
        fields: ['mdFileURL', 'markdown'],
      },
    ],
    properties: {
      title: {
        title: 'Title',
        widget: 'text',
      },
      description: {
        title: 'Description',
        widget: 'text',
      },
      align: {
        title: 'Align',
	widget: 'align',
      },
      theme: {
        title: 'Theme',
	initialValue: 'night',
        widget: 'select',
	isMulti: false,
	choices: [
	  ['beige','beige'],
	  ['black','black'],
	  ['black-contrast','black-contrast'],
	  ['blood','blood'],
	  ['dracula','dracula'],
	  ['league','league'],
	  ['moon','moon'],
	  ['night','night'],
	  ['serif','serif'],
	  ['simple','simple'],
	  ['sky','sky'],
	  ['solarized','solarized'],
	  ['white','white'],
	  ['white-contrast','white-contrast'],
	  ['white_contrast_compact_verbatim_headers','white_contrast_compact_verbatim_headers'],
	],
      },
      transition: {
        title: 'Transition',
	initialValue: 'slide',
        widget: 'select',
	isMulti: false,
	choices: [
	  ['none', 'none'],
	  ['fade', 'fade'],
	  ['slide', 'slide'],
	  ['convex', 'convex'],
	  ['concave', 'concave'],
	  ['zoom', 'zoom'],
	],
      },
      autoslide: {
	title: 'Autoslide (msec)',
	type: 'number',
	initialValue: 0,
      },
      // fields: ['loop', 'controls', 'keyboard'],
      loop: {
	title: 'Loop',
	type: 'boolean',
	initialValue: false,
      },
      controls: {
	title: 'Controls',
	type: 'boolean',
	initialValue: true,
      },
      keyboard: {
	title: 'Keyboard',
	type: 'boolean',
	initialValue: true,
      },
      mdFileURL: {
        title: 'Markdown URL',
        widget: 'object_browser',
        mode: 'link',
        allowExternals: true,
      },
      markdown: {
        title: 'Markdown',
	initialValue: '',
        widget: 'textarea',
      },
      height: {
        title: 'Slide Height',
	initialValue: '40vh',
        widget: 'text',
      },
      scrollactivationwidth: {
	title: 'Scroll Activation Width',
	type: 'number',
	initialValue: 0,
      },
    },
  };
};

export default schemaReveal;
